import http from "../http-common"; 

class SubmenuService {
  getAllSubmenus(searchDTO) {
    console.log(searchDTO)
    return this.getRequest(`/submenu/submenus`, searchDTO);
  }

  get(submenuId) {
    return this.getRequest(`/submenu/${submenuId}`, null);
  }

  findByField(matchData) {
    return this.getRequest(`/submenu?field=${matchData}`, null);
  }

  addSubmenu(data) {
    return http.post("/submenu/addSubmenu", data);
  }

  update(data) {
  	return http.post("/submenu/updateSubmenu", data);
  }
  
  uploadImage(data,submenuId) {
  	return http.postForm("/submenu/uploadImage/"+submenuId, data);
  }




	postRequest(url, data) {
        const token = localStorage.getItem('authToken');
        if (token) {
            return http.post(url, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
        }
      };

	getRequest(url, params) {
        const token = localStorage.getItem('authToken');
        if (token) {
            return http.get(url, {
            	params: params,
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
        }
    };

}

export default new SubmenuService();
